module.exports = __webpack_public_path__ + "img/freestyle_box20.5f1cd4f6.jpg";